import { type Breakpoints, type BreakpointValues } from 'app/constants/breakpoints';
import { generateBreakpointValues } from '../generate-breakpoint-values';

const getBreakpointValue = <T = string>(initialBreakpointValues: BreakpointValues<T>, active: Breakpoints) => {
  const breakpointValues = generateBreakpointValues<T>(initialBreakpointValues);
  return breakpointValues[active];
};

export default getBreakpointValue;
